import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { useApp } from '../context/AppContext';
import { privacyContent, PRIVACY_EMAIL } from '../i18n/privacyContent';

export const PrivacyPolicy = () => {
  const { state } = useApp();
  const lang = state.language === 'en' ? 'en' : 'it';
  const content = privacyContent[lang];

  return (
    <div className="min-h-screen bg-[var(--background)] text-[var(--text)]">
      <div className="mx-auto max-w-2xl px-5 py-[max(1.5rem,env(safe-area-inset-top))] pb-12">
        <Link
          to="/"
          className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-[var(--primary)] hover:text-[var(--primary-hover)]"
        >
          <ArrowLeft size={18} weight="bold" />
          {content.backToApp}
        </Link>

        <header className="mb-8">
          <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{content.title}</h1>
          <p className="mt-2 text-sm text-[var(--text-muted)]">{content.lastUpdated}</p>
        </header>

        <article className="space-y-8">
          {content.sections.map((section) => (
            <section key={section.title}>
              <h2 className="mb-3 text-lg font-semibold">{section.title}</h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="mb-3 text-sm leading-relaxed text-[var(--text-muted)]">
                  {paragraph}
                </p>
              ))}
              {section.list && (
                <ul className="mb-3 list-disc space-y-2 pl-5 text-sm leading-relaxed text-[var(--text-muted)]">
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
              {section.paragraphsAfter?.map((paragraph) => (
                <p key={paragraph} className="mb-3 text-sm leading-relaxed text-[var(--text-muted)]">
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </article>

        <footer className="mt-10 border-t border-[var(--border)] pt-6 text-sm text-[var(--text-muted)]">
          <p>
            {lang === 'it' ? 'Contatto privacy:' : 'Privacy contact:'}{' '}
            <a
              href={`mailto:${PRIVACY_EMAIL}`}
              className="text-[var(--primary)] underline underline-offset-2 hover:text-[var(--primary-hover)]"
            >
              {PRIVACY_EMAIL}
            </a>
          </p>
        </footer>
      </div>
    </div>
  );
};
